<template>
  <div></div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";

export default {
  name: "admin-dashboard",
  components: {},
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "داشبورد مدیریت"
      }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});
  },
  computed: {},
  methods: {}
};
</script>
